import __var_0__ from '@stdlib/utils/define-read-only-property';
import __var_1__ from '@stdlib/strided/base/binary';
import __var_2__ from '@stdlib/strided/base/dmap';
import __var_3__ from '@stdlib/strided/base/dmskmap';
import __var_4__ from '@stdlib/strided/base/mskunary';
import __var_5__ from '@stdlib/strided/base/nullary';
import __var_6__ from '@stdlib/strided/base/quaternary';
import __var_7__ from '@stdlib/strided/base/quinary';
import __var_8__ from '@stdlib/strided/base/smap';
import __var_9__ from '@stdlib/strided/base/smskmap';
import __var_10__ from '@stdlib/strided/base/ternary';
import __var_11__ from '@stdlib/strided/base/unary';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //
var setReadOnly = __var_0__;


// MAIN //

/**
* Top-level namespace.
*
* @namespace ns
*/
var ns = {};

/**
* @name binary
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/binary}
*/
setReadOnly( ns, 'binary', __var_1__);

/**
* @name dmap
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/dmap}
*/
setReadOnly( ns, 'dmap', __var_2__);

/**
* @name dmskmap
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/dmskmap}
*/
setReadOnly( ns, 'dmskmap', __var_3__);

/**
* @name mskunary
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/mskunary}
*/
setReadOnly( ns, 'mskunary', __var_4__);

/**
* @name nullary
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/nullary}
*/
setReadOnly( ns, 'nullary', __var_5__);

/**
* @name quaternary
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/quaternary}
*/
setReadOnly( ns, 'quaternary', __var_6__);

/**
* @name quinary
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/quinary}
*/
setReadOnly( ns, 'quinary', __var_7__);

/**
* @name smap
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/smap}
*/
setReadOnly( ns, 'smap', __var_8__);

/**
* @name smskmap
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/smskmap}
*/
setReadOnly( ns, 'smskmap', __var_9__);

/**
* @name ternary
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/ternary}
*/
setReadOnly( ns, 'ternary', __var_10__);

/**
* @name unary
* @memberof ns
* @readonly
* @type {Function}
* @see {@link module:@stdlib/strided/base/unary}
*/
setReadOnly( ns, 'unary', __var_11__);


// EXPORTS //
export default ns;

export { __var_1__ as binary, __var_2__ as dmap, __var_3__ as dmskmap, __var_4__ as mskunary, __var_5__ as nullary, __var_6__ as quaternary, __var_7__ as quinary, __var_8__ as smap, __var_9__ as smskmap, __var_10__ as ternary, __var_11__ as unary};